<script>
// app/javascript/dashboard/routes/dashboard/settings/inbox/channels/SmsFly.vue
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      apiKey: '',
      smsSource: 'vngsm',
      viberSource: 'vngsm.com.ua',
      viberButtonText: 'napisati nam',
      viberButtonUrl: 'viber://pa?chatURI=vngsmcomua',
      defaultTtl: 60,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    apiKey: { required },
    smsSource: { required },
    viberSource: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const smsFlyChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            channel: {
              type: 'sms_fly',
              api_key: this.apiKey,
              sms_source: this.smsSource,
              viber_source: this.viberSource,
              viber_button_text: this.viberButtonText,
              viber_button_url: this.viberButtonUrl,
              default_ttl: this.defaultTtl,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: smsFlyChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message ||
            this.$t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.DESC')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <!-- API Key -->
      <div class="flex-shrink-0 flex-grow-0 mb-4">
        <label :class="{ error: v$.apiKey.$error }">
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.API_KEY.LABEL') }}
          <input
            v-model="apiKey"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.API_KEY.PLACEHOLDER')
            "
            @blur="v$.apiKey.$touch"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.API_KEY.SUBTITLE') }}
        </p>
      </div>

      <!-- SMS Source -->
      <div class="flex-shrink-0 flex-grow-0 mb-4">
        <label :class="{ error: v$.smsSource.$error }">
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.SMS_SOURCE.LABEL') }}
          <input
            v-model="smsSource"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.SMS_SOURCE.PLACEHOLDER')
            "
            @blur="v$.smsSource.$touch"
          />
        </label>
      </div>

      <!-- Viber Source -->
      <div class="flex-shrink-0 flex-grow-0 mb-4">
        <label :class="{ error: v$.viberSource.$error }">
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.VIBER_SOURCE.LABEL') }}
          <input
            v-model="viberSource"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.VIBER_SOURCE.PLACEHOLDER')
            "
            @blur="v$.viberSource.$touch"
          />
        </label>
      </div>

      <!-- Viber Button Text -->
      <div class="flex-shrink-0 flex-grow-0 mb-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.VIBER_BUTTON_TEXT.LABEL') }}
          <input
            v-model="viberButtonText"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.VIBER_BUTTON_TEXT.PLACEHOLDER')
            "
          />
        </label>
      </div>

      <!-- Viber Button URL -->
      <div class="flex-shrink-0 flex-grow-0 mb-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.VIBER_BUTTON_URL.LABEL') }}
          <input
            v-model="viberButtonUrl"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.VIBER_BUTTON_URL.PLACEHOLDER')
            "
          />
        </label>
      </div>

      <!-- TTL -->
      <div class="flex-shrink-0 flex-grow-0 mb-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.TTL.LABEL') }}
          <input
            v-model.number="defaultTtl"
            type="number"
            min="1"
            max="1440"
            :placeholder="$t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.TTL.PLACEHOLDER')"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.TTL.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.SMS_FLY_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
